import { gql } from '@apollo/client'

const GET_DIMENSIONS_QUERY = gql`
  query getDimensions($nonprofitOrgId: Int!) {
    getDimensions(nonprofitOrgId: $nonprofitOrgId) {
      id
      title
      isHidden
    }
  }
`

export default GET_DIMENSIONS_QUERY
